<template>
  <GridBase gak-common class="gak-chuncheon">
    <section class="top">
      <h1>
        <p><q>GAK</q><br /><q>CHUNCHEON</q></p>
      </h1>
    </section>
    <section class="s1 j">
      <PrSplit class="v1" type="type0" img="/img/dc/chuncheon/bg-s1.jpg">
        <div class="title">
          <TextBlock file="dc/chuncheon-data-t1" class="pre-line q j" data-offset="100"/>
        </div>
      </PrSplit>
      <TextBlock
        file="dc/chuncheon-data-t1-1"
        class="pre-line q j"
        data-offset="100"
      />
    </section>
    <section class="s2 j" data-offset="0">
      <PrHoldOrNot img="/img/dc/chuncheon/bg-s2.jpg" title="Location" mobile-height="375">
        <template v-slot:holdRight>
          <div
            class="dc-sample-s2-exp"
            data-p="0.4,1"
            data-px="-100,0"
            data-a="0,1"
          >
            <h3>This is <br />Chuncheon, Gangwon-do</h3>
            <div class="cover">
              <h4>
                The first step for<br class="hidden-md-down"> building a data center, <br>securing power and<br class="hidden-md-down"> communication network
              </h4>
              <h5>
                DATA CENTER GAK Chuncheon gets up to 40,000 kW of electricity from two substations within its 10 km radius.
              </h5>
            </div>
          </div>
        </template>

        <div class="dc-sample-s2-exp">
          <div class="img">Location</div>
          <h3 class="q">
            This is Chuncheon, <br class="hidden-md-down" />Gangwon-do
          </h3>
          <div class="cover">
            <h4 class="q">
              The first step for building a data center, <br class="hidden-md-down" />securing power and communication network
            </h4>
            <p class="q">
              DATA CENTER GAK Chuncheon gets up to 40,000 kW of electricity from two substations within its 10 km radius.
            </p>
          </div>
        </div>
      </PrHoldOrNot>
    </section>
    <section class="s3">
      <PrBlock class="v3 j">
        <img
          src="/img/dc/chuncheon/bg-s3-1.jpg"
          alt=""
          data-p="0.5,0.8"
          data-y="0,-10"
        />
        <img
          src="/img/dc/chuncheon/bg-s3-2.jpg"
          alt=""
          data-p="0.5,0.9"
          data-y="0,40"
        />
      </PrBlock>
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t2" class="pre-line q" /></h4>
        <p class="q">
          The average annual temperature in Chuncheon is 1 to 2 degrees lower than in the capital metropolitan area, so the data center can be operated on natural wind for a longer period within a year of 365 days, which has the effect of reducing air conditioning costs in an eco-friendly way. Although earthquakes have become more frequent on the Korean Peninsula recently, Chuncheon is one of the cities least affected by them over the past few decades.
        </p>
      </div>
    </section>
    <section class="s8 j">
      <PrSplit class="vis" img="/img/dc/chuncheon/bg-s9.jpg" title="Technology" bottom-free/>
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t3" class="pre-line q" /></h4>
        <p class="q">
          DATA CENTER GAK Chuncheon aims to become energy efficient, <br class="hidden-md-down" />
          with safer and more accurate technology that coexists with nature.
        </p>
      </div>
      <quick-link-item type="gray">
        <a class="" href="/tech/technology">See in Technology</a>
      </quick-link-item>
    </section>
    <section class="s4 j">
      <PrSplit
        class="v4 j"
        img="/img/dc/chuncheon/bg-s4.jpg"
        title="Architecture"
      />
      <div class="exp">
        <h3>Nature meets <br />safety</h3>
        <p class="map"><q></q></p>
        <h4><TextBlock file="dc/chuncheon-data-t4" class="pre-line q" /></h4>
        <p class="q">
          DATA CENTER GAK Chuncheon is built in a way the central building is surrounded by three other buildings. <br />
          Servers are spread to different buildings for better safety, easier expansion according to the speed of increasing data, and higher energy efficiency.
        </p>
      </div>
      <video
        :src="`${videoBase}/chuncheon.mp4`"
        muted
        autoplay
        loop
        playsinline
        class="pic"
      />
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t4-1" class="pre-line q" /></h4>
        <p class="q">
          The buildings form a V-shape so that the wind blowing through the terrain can help cool the heat from our servers. <br/>
          While keeping the width of the buildings wide to have a sufficient area catching the wind, they are curved in a V-shape and placed with enough gaps in between to ensure good airflow.
        </p>
      </div>
    </section>
    <section class="s5">
      <PrSplit class="v5" type="type2" img="/img/dc/chuncheon/bg-s6.jpg" />
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t5" class="pre-line q" /></h4>
        <p class="q">
          Louvers painted the color of Janggyeonggak to go with the natural environment keeps sunlight out to increase the efficiency of air conditioning.
        </p>
      </div>
    </section>
    <section class="s6">
      <PrSplit class="v6" type="type3" img="/img/dc/chuncheon/bg-s7.jpg" />
      <div class="exp">
        <h4 class="q">Terraced low-rise structure <br />in tune with nature</h4>
        <p class="q">
          DATA CENTER GAK Chuncheon's terraced low-rise structure, sitting wide and low along the incline of the land, is designed to be in tune with nature. <br />
          The lower height in architecture makes it relatively safe from fire or earthquakes, while the network is also easier to control as its structure is simpler.
        </p>
      </div>
    </section>
    <section class="s7">
      <PrSplit
        class="v7 q"
        type="type4"
        img="/img/dc/chuncheon/bg-s8.jpg"
        :alpha50="false"
      />
      <div class="exp">
        <h4 class="q">
          Defending the ecological axis <br/>
          with trees and grass
        </h4>
        <p class="q">
          We created a little forest on more than half of the building's rooftop area by planting trees and grass, to keep the ecological axis of Mountain Gubong. <br />
          The greenery on the rooftop shields the sun's scorching heat in the summer and retains the building's warmth in the winter, reducing thermal power consumption and preventing heat island effect.
        </p>
      </div>
    </section>

    <div class="feature j">
      <section class="s9 gallery">
        <PrSplit v-if="sect === 'sm'" class="v9" img="/img/dc/chuncheon/bg-gallery.jpg" title="GAK Chuncheon Gallery" overflowTitle=""/>
        <PrSplit v-else class="v9" img="/img/dc/chuncheon/bg-gallery-pc.jpg" title="GAK Chuncheon Gallery" overflowTitle=""/>
      </section>
      <SliderTumbs navigation="true">
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-01.jpg" />
          </div>
          <div class="txt">
            <p>Electrical room designed with redundant power system for reliable and uninterrupted power supply</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-02.jpg" />
          </div>
          <div class="txt">
            <p>Dynamic UPS that provides uninterrupted server power even during power outages with energy storage rotors and emergency engine operation</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-03.jpg" />
          </div>
          <div class="txt">
            <p>STS, a backup device at the end of a UPS that automatically connects to another spare line to provide power when power is lost</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-04.jpg" />
          </div>
          <div class="txt">
            <p>NAMU, NAVER's self-developed air conditioning facility that uses natural wind to cool server heat</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-05.jpg" />
          </div>
          <div class="txt">
            <p>Server room of DATA CENTER GAK, designed to deliver secure and efficient IT services</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-06.jpg" />
          </div>
          <div class="txt">
            <p>Louvers that take into account the sun and wind paths to increase the cooling effect of the building (with unique colors for Janggyeonggak)</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-07.jpg" />
          </div>
          <div class="txt">
            <p>Machine room optimally designed for energy savings and efficiency</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-08.jpg" />
          </div>
          <div class="txt">
            <p>Exclusive NAVER racks developed in-house to improve server density</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-09.jpg" />
          </div>
          <div class="txt">
            <p>High-powered server racks with 11 kW of power per rack, twice the capacity of a typical rack</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-10.jpg" />
          </div>
          <div class="txt">
            <p>Solar arrays installed in parking lots and spare land to reduce data center greenhouse gas emissions</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-11.jpg" />
          </div>
          <div class="txt">
            <p>Eco-friendly greenhouse powered by solar energy</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-12.jpg" />
          </div>
          <div class="txt">
            <p>Architectural greening to keep buildings out of direct sunlight and maintain indoor temperature and humidity</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-13.jpg" />
          </div>
          <div class="txt">
            <p>Smart Server Farm, a modular, containerized data center developed in-house to provide optimized IT infrastructure</p>
          </div>
        </div>
      </SliderTumbs>
      <article class="bottom">
        <GridBase b50>
          <TextBlock file="dc/chuncheon-data-t6" class="q pre-line" />
          <!-- <p class="q">
            *Ark: an archaic word for a chest, most famously "the ark of the covenant"<br /> held two stone tablets inscribed with the Ten Commandments.
          </p> -->
        </GridBase>
        <quick-link>
          <quick-link-item><router-link to="gak-global">GAK <br class="hidden-md-up" />Global</router-link></quick-link-item>
          <quick-link-item type="gray"><a class="launch" target="_blank" href="https://datacenter.ncloud.com/">GAK<br class="hidden-md-up" /> Chuncheon<br />Virtual tour</a></quick-link-item>
        </quick-link>
      </article>
    </div>
  </GridBase>
</template>

<script>
import GridBase from "@/views/components/GridBase";
import PrSplit from "@/views/components/PrSplit";
import TextBlock from "@/views/components/TextBlock";
import PrHoldOrNot from "@/views/components/PrHoldOrNot";
import PrBlock from "@/views/components/PrBlock";
import feature from "@/data/gak/chuncheonFeatureEN";
import QuickLink from "@/views/components/QuickLink";
import QuickLinkItem from "@/views/components/QuickLinkItem";
import SliderTumbs from "@/views/components/SliderTumbs";
import { getOffsetLeft } from "@/utils";

export default {
  name: "gak-chuncheon",
  components: {
    SliderTumbs,
    QuickLinkItem,
    QuickLink,
    PrBlock,
    PrHoldOrNot,
    TextBlock,
    PrSplit,
    GridBase,
  },
  data() {
    return {
      f2Active: -1,
      f3Active: -1,
      feature,
      f1: feature[0],
      f2: feature[1],
      f3: feature[2],
    };
  },
  watch: {},
  computed: {
    chuncheonPopupStatus() {
      return this.$store.state.chuncheonPopup;
    },
  },
  methods: {
    showPopupF1(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-01",
        idx,
        info: this.f1,
      });
    },
    showPopupF2(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-02",
        idx,
        info: this.f2,
      });
    },
    resetF2(idx, el) {
      this.f2Active = idx;
      const right =
        getOffsetLeft(el) +
        +el.parentNode.style.transform.match(/(-?\d+)px/)[1] +
        el.offsetWidth;
      if (right > window.innerWidth) this.$refs.f2slide.next();
    },
    resetF3(idx) {
      if (this.sect === "sm" || this.sect === "md") {
        this.$store.commit("setChuncheonPopup", {
          type: "type-03",
          idx,
          info: this.f3,
        });
      } else {
        this.f3Active = this.f3Active === idx ? null : idx;
      }
    },
    closePopup() {
      this.$store.commit("setChuncheonPopup", null);
    },
    resize() {
      this.closePopup();
    },
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
};
</script>
